'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWifiLock = function MdWifiLock(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 26.6v-2.5c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v2.5h5z m1.8 0c0.9 0 1.6 0.8 1.6 1.8v6.6c0 0.9-0.7 1.6-1.6 1.6h-8.4c-0.9 0-1.6-0.7-1.6-1.6v-6.6c0-1 0.7-1.8 1.6-1.8v-2.5c0-2.2 1.9-4.1 4.1-4.1s4.3 1.9 4.3 4.1v2.5z m-4.3-10.7c-4.6 0-8.2 3.6-8.2 8.2v4.8l-5.9 7.7-20-26.6c5.5-4.2 12.5-6.6 20-6.6s14.5 2.4 20 6.6l-4.5 5.9c-0.4 0-0.9 0-1.4 0z' })
        )
    );
};

exports.default = MdWifiLock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wifi-lock.js
// module id = 3953
// module chunks = 168707334958949